import { useState, type FormEvent } from "react";
import { LockKeyhole, ShieldCheck } from "lucide-react";
import { AuthError, login } from "./api";

const DEV = import.meta.env.DEV;

export function LoginGate({ onSuccess }: { onSuccess: (user: string) => void }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [status, setStatus] = useState<"idle" | "loading">("idle");
  const [error, setError] = useState("");

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!username.trim() || !password) {
      setError("Podaj login i hasło administratora.");
      return;
    }
    setStatus("loading");
    setError("");
    try {
      const user = await login(username.trim(), password);
      onSuccess(user);
    } catch (err) {
      setStatus("idle");
      if (err instanceof AuthError) {
        setError("Błędny login lub hasło.");
      } else if (err instanceof Error && err.message === "ADMIN_NOT_CONFIGURED") {
        setError("Panel nie ma jeszcze ustawionych danych logowania (ADMIN_USERNAME / ADMIN_PASSWORD).");
      } else {
        setError("Nie udało się połączyć z panelem. Spróbuj ponownie.");
      }
    }
  };

  return (
    <div className="crm-login">
      <form className="crm-login-card" onSubmit={submit}>
        <div className="crm-login-brand">
          <span className="crm-brand-mark">
            <ShieldCheck size={22} aria-hidden="true" />
          </span>
          <div>
            <strong>Ochro</strong>
            <span className="crm-brand-tag">CRM</span>
          </div>
        </div>

        <h1>Panel sprzedaży</h1>
        <p className="crm-login-lead">Zaloguj się, aby zarządzać zgłoszeniami i lejkiem sprzedaży.</p>

        <label className="crm-field">
          <span>Login</span>
          <input
            value={username}
            autoComplete="username"
            autoCapitalize="none"
            spellCheck={false}
            onChange={(event) => setUsername(event.target.value)}
            placeholder="np. admin"
          />
        </label>

        <label className="crm-field">
          <span>Hasło</span>
          <input
            value={password}
            type="password"
            autoComplete="current-password"
            onChange={(event) => setPassword(event.target.value)}
            placeholder="••••••••"
          />
        </label>

        {error && (
          <p className="crm-login-error" role="alert">
            {error}
          </p>
        )}

        <button className="crm-btn crm-btn--primary crm-btn--block" type="submit" disabled={status === "loading"}>
          <LockKeyhole size={18} aria-hidden="true" />
          {status === "loading" ? "Logowanie…" : "Zaloguj się"}
        </button>

        {DEV && (
          <p className="crm-login-hint">
            Tryb demo (offline): <code>admin</code> / <code>Ochro2026!</code>
          </p>
        )}

        <p className="crm-login-foot">
          Dostęp tylko dla obsługi Ochro.pl. Strona nie jest indeksowana.
        </p>
      </form>
    </div>
  );
}
